/**
 * @file
 * Initialize lightbox Plugin
 *
 * This plugin is used to generate a lightbox/modal for images to show a larger
 * version of the image.
 */

(function ($, Drupal) {
  Drupal.behaviors.lightbox = {
    attach: function attach(context) {
      lightbox.option({
        'resizeDuration': 200,
        'alwaysShowNavOnTouchDevices': true,
        'showImageNumberLabel': false
      })
    }
  };
})(jQuery, Drupal);


